import {
  Grid,
  Box,
  Typography,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  SelectChangeEvent
} from '@mui/material'
import { FC, ReactNode, useState } from 'react'
import { DatePickerComponent } from '../../components/DatePicker/DatePickerComponent'
import ClockIcon from '../../images/clockIcon.svg'
import { makeStyles } from '@mui/styles'
import { appTheme } from '../../theme'
import Slots from '../TimeSlot/Slots'

const useStyles = makeStyles({
  datepickerWrapper: {
    // margin: 'auto',
    maxWidth: '276px',
    padding: '0px',
    background: 'white',
    borderRadius: '4px'
  },
  eventTitle: {
    maxWidth: '276px',
    [appTheme.breakpoints.down('md')]: {
      margin: 'auto'
    }
  },
  formControl: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#006BD7'
    }
    // '& .MuiOutlinedInput-notchedOutline': {
    //   borderRadius: '8px'
    // }
  }
})

const HorizontalLine = () => {
  return (
    <Box
      sx={{
        width: '100%',
        border: '0.5px solid #C9C5CA'
      }}
    ></Box>
  )
}
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 3.5 + ITEM_PADDING_TOP,
      width: 172
    }
  }
}

interface EventDateAndTimeProps {
  eventName: string
  minimumDate?: Date
  maximumDate?: Date
  eventDate: Date
  duration: number | string
  setEventDate: any
  setLiveSlot?: any
  handleDuration?:
    | ((event: SelectChangeEvent<any>, child: ReactNode) => void)
    | undefined
  selectedSlot?: string
  availableSlots?: string[]
  clickSlot?: any
  blockedDates?: string[]
  faqTime?: React.ReactNode | string
  faqDate: React.ReactNode | string
}

export const EventDateAndTime: FC<EventDateAndTimeProps> = ({
  eventName,
  minimumDate,
  maximumDate,
  eventDate,
  duration,
  setEventDate,
  setLiveSlot,
  handleDuration,
  selectedSlot,
  availableSlots,
  clickSlot,
  blockedDates,
  faqTime,
  faqDate
}: any) => {
  const classes = useStyles()

  const [openSlot, setOpenSlot] = useState(false)
  return (
    <>
      {/* Live Event Date */}
      <Grid item sm={12}>
        <Box className={classes.eventTitle}>
          <Typography align='left' variant='h5'>
            {eventName} Date
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        sm={12}
        container
        sx={{
          gridAutoFlow: 'row',
          justifyContent: {
            xs: 'center',
            sm: 'space-between',
            md: 'space-between',
            lg: 'space-between'
          },

          gridRowGap: '2rem'
        }}
      >
        <Box className={classes.datepickerWrapper}>
          <DatePickerComponent
            maximumDate={maximumDate}
            minimumDate={minimumDate}
            eventDate={eventDate!}
            setEventDate={setEventDate}
            setLiveSlot={setLiveSlot}
            blockedDates={blockedDates}
          />
        </Box>
        <Box sx={{ width: '425px' }}>
          <Typography
            sx={{
              fontSize: '16px !important',
              fontWeight: '400',
              lineHeight: '24px',
              letter: '2%',
              textAlign: 'left',
              color: '#79747E'
            }}
          >
            {faqDate}
          </Typography>
        </Box>
      </Grid>

      {/* Live Event Time */}
      {availableSlots && (
        <>
          <HorizontalLine />
          <Grid item sm={12}>
            <Box className={classes.eventTitle}>
              <Typography align='left' variant='h5'>
                Event Time
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            sm={12}
            container
            sx={{
              gridAutoFlow: 'row',
              justifyContent: {
                xs: 'center',
                sm: 'space-between',
                md: 'space-between',
                lg: 'space-between'
              },
              gridRowGap: '2rem'
            }}
          >
            <Box
              className={classes.datepickerWrapper}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <FormControl
                sx={{ minWidth: '225px' }}
                size='small'
                className={classes.formControl}
              >
                <Select
                  fullWidth
                  value={duration.toString()}
                  onChange={handleDuration}
                  MenuProps={MenuProps}
                  sx={{
                    textAlign: 'left',
                    ml: { md: -1.2, sm: -1 }
                  }}
                >
                  <MenuItem value={30}>30 Minutes</MenuItem>
                  <MenuItem value={60}>60 Minutes</MenuItem>
                  <MenuItem value={90}>90 Minutes</MenuItem>
                </Select>
              </FormControl>

              <TextField
                fullWidth
                label='Time'
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <Box component='img' src={ClockIcon} alt='Clock Icon' />
                    </InputAdornment>
                  ),
                  style: {
                    height: '40px',
                    width: '225px'
                  }
                }}
                onClick={() => {
                  setOpenSlot(true)
                }}
                value={selectedSlot}
                sx={{
                  [`& fieldset`]: {
                    borderRadius: '4px'
                  },
                  '.MuiOutlinedInput-root.Mui-focused': {
                    fieldset: { borderColor: '#006BD7' }
                  }
                }}
              />
              <Slots
                open={openSlot}
                setOpen={setOpenSlot}
                selectedSlot={selectedSlot}
                availableSlots={availableSlots}
                setSlot={clickSlot}
              />
            </Box>
            <Box sx={{ width: '425px' }}>
              <Typography
                sx={{
                  fontSize: '16px !important',
                  fontWeight: '400',
                  lineHeight: '24px',
                  letter: '2%',
                  textAlign: 'left',
                  color: '#79747E'
                }}
              >
                {faqTime}
              </Typography>
            </Box>
          </Grid>
          <HorizontalLine />
        </>
      )}
    </>
  )
}
